import {CommonRootState} from '../types';

export const selectAmbientWeatherConnectedAt = (state: CommonRootState) =>
  state.ambientWeather.link && state.ambientWeather.link.date_connected;

export const selectAmbientWeatherConnected = (state: CommonRootState) =>
  state.ambientWeather.link !== null;

export const selectAmbientWeatherActive = (state: CommonRootState) =>
  state.ambientWeather.link !== null &&
  state.ambientWeather.link.account.active;
